import BaseService from '../../BaseService.js';

export default class ExportService extends BaseService {
  constructor() {
    super('export')
  }
}
